<template>
<SidebarBase>
  <template #categories="{ visibleCategoriesTree }">
    <ul>
      <CategoryInlineNested
        v-for="c of visibleCategoriesTree"
        :category="c"
        :key="c.id"
      />
    </ul>
  </template>
</SidebarBase>
</template>

<script>
import SidebarBase from '../Base';
import CategoryInlineNested from '../categories/InlineNested';

export default {
  components: {
    SidebarBase,
    CategoryInlineNested,
  },
}
</script>
